const pageNameKey = "usersListView";

export const usersListViewEn = {
  [pageNameKey]: {
    subtitle: "Users List",
    addNewUserButton: "Add New User",
    disabledAddNewUserButtonTooltip:
      "You do not have permissions to add a new user.",
    errorLoadingUsersText: "Failed to load users",
    errorLoadingValidUserRolesText: "Failed to load valid user roles",
  },
};

export const usersListViewPtBr = {
  [pageNameKey]: {
    subtitle: "Lista de usuários",
    addNewUserButton: "Adicionar novo usuário",
    disabledAddNewUserButtonTooltip:
      "Você não tem permissão para adicionar um novo usuário.",
    errorLoadingUsersText: "Falha ao carregar usuários",
    errorLoadingValidUserRolesText:
      "Falha ao carregar funções de usuário válidas",
  },
};

export const usersListViewDe = {
  [pageNameKey]: {
    subtitle: "Benutzerliste",
    addNewUserButton: "Neuen Benutzer hinzufügen",
    disabledAddNewUserButtonTooltip:
      "Sie haben keine Berechtigung, einen neuen Benutzer hinzuzufügen.",
    errorLoadingUsersText: "Fehler beim Laden der Benutzer",
    errorLoadingValidUserRolesText: "Fehler beim Laden der Benutzerrollen",
  },
};

export const usersListViewZhHans = {
  [pageNameKey]: {
    subtitle: "用户列表",
    addNewUserButton: "添加新用户",
    disabledAddNewUserButtonTooltip: "您没有权限添加新用户。",
    errorLoadingUsersText: "加载用户失败",
    errorLoadingValidUserRolesText: "加载有效用户角色失败",
  },
};

export const usersListViewIt = {
  [pageNameKey]: {
    subtitle: "Elenco Utenti",
    addNewUserButton: "Aggiungi Utente",
    disabledAddNewUserButtonTooltip:
      "Non hai i permessi per aggiungere un nuovo utente.",
    errorLoadingUsersText: "Impossibile caricare gli utenti",
    errorLoadingValidUserRolesText: "Impossibile caricare ruoli utente validi",
  },
};

export const usersListViewEs = {
  [pageNameKey]: {
    subtitle: "Lista de usuarios",
    addNewUserButton: "Agregar nuevo usuario",
    disabledAddNewUserButtonTooltip:
      "No tienes permisos para agregar un nuevo usuario.",
    errorLoadingUsersText: "No se pudieron cargar los usuarios",
    errorLoadingValidUserRolesText:
      "No se pudieron cargar los roles de usuario válidos",
  },
};

export const usersListViewNl = {
  [pageNameKey]: {
    addNewUserButton: "Nieuwe gebruiker toevoegen",
    disabledAddNewUserButtonTooltip:
      "U heeft geen rechten om een nieuwe gebruiker toe te voegen.",
    errorLoadingUsersText: "Fout bij het laden van gebruikers",
    errorLoadingValidUserRolesText: "Fout bij het laden van gebruikersrollen",
    subtitle: "Gebruikerslijst",
  },
};

export const usersListViewTr = {
  [pageNameKey]: {
    addNewUserButton: "Yeni Kullanıcı Ekle",
    disabledAddNewUserButtonTooltip: "Yeni kullanıcı ekleme izniniz yok.",
    errorLoadingUsersText: "Kullanıcılar yüklenemedi",
    errorLoadingValidUserRolesText: "Geçerli kullanıcı rolleri yüklenemedi",
    subtitle: "Kullanıcı Listesi",
  },
};
